export const formatTotal = (value: any) => {
	if (isNaN(value)) return value;
	return new Intl.NumberFormat("en-us", { minimumFractionDigits: 0 }).format(value);
};